/* eslint-disable no-undef */
import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewport } from '../getViewport';

export const storyQuote = () => {
  const storyQuotes = $$('.story-quote');

  if (storyQuotes.length) {
    storyQuotes.forEach(quote => {
      const quoteImage = $('.story-quote__image', quote);
      const quoteText = $('.story-quote__text', quote);

      gsap.set(quoteImage, { rotation: viewport.isReduced ? 0 : 8 });
      gsap.set(quoteText, { y: viewport.isReduced ? 0 : 100 });

      const timeline = gsap.timeline();

      timeline.to(quoteImage, { rotation: 0 });
      timeline.to(quoteText, { y: 0 }, '<=+30%');

      ScrollTrigger.create({
        animation: timeline,
        trigger: quoteImage,
        start: () => 'top 95%',
        end: () =>
          viewport.isDesktop
            ? 'end center'
            : viewport.isTablet
            ? 'end center'
            : viewport.isMobile
            ? 'end end'
            : '',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });
  }
};
